<template>
<v-layout>
	<Item :list="czIscos"
		@add="addCzIsco"
		@remove="removeCzIsco"
		@edit="changeCzIsco"
		:label="$t('workers.cz_isco')"
	/>
</v-layout>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Item from '../Item'
export default {
	components: {
		Item
	},
	methods: {
		...mapMutations({
			addCzIsco: 'settings/addCzIsco',
			removeCzIsco: 'settings/removeCzIsco',
			changeCzIsco: 'settings/changeCzIsco'
		})
	},
	computed: {
		...mapState({
			czIscos: ({ settings }) => settings.settings.czIscos
		})
	}
}
</script>
